<template>
  <div id="app">
    <site_header :headerData="constants.header" />
    <banner :slides="constants.homepageBannerSlides" />
    <ps_services :services="constants.services" :sid="currentServiceId" />
    <our_mission :missionStatement="constants.missionStatement" />
    <photo_gallery :photos="constants.photoGallery" />
    <testimonials :quoteData="constants.quoteData" />
    <contact_form :services="getServicesSimplified" :currentServiceId="currentServiceId" :contactInfo="constants.contactInfo" />
    <site_footer />
  </div>
</template>

<script>
import constants from '@/constants.json'
import site_header from './components/Header.vue'
import banner from './components/Banner.vue'
import ps_services from './components/PSServices.vue'
import our_mission from './components/OurMission.vue'
import photo_gallery from './components/PhotoGallery.vue'
import testimonials from './components/Testimonials.vue'
import contact_form from './components/ContactForm.vue'
import site_footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    site_header,
    banner,
    ps_services,
    our_mission,
    photo_gallery,
    testimonials,
    contact_form,
    site_footer
  },
  data() {
    return {
      constants : constants,
      currentServiceId : -1,
    }
  },
  methods : {
    setCurrentServiceId : function(serviceId) {
      this.currentServiceId = serviceId;
		},
    resetCurrentServiceId : function() {
      this.currentServiceId = -1;
    },
  },
  computed : {
    getServicesSimplified : function() {
      var simplified = [];
      this.constants.services.forEach(function(s){
        simplified.push({ id : s.id, title : s.title });
      });
      return simplified;
    },
  }
}
</script>